import { useEffect, useState } from "react";

type TCountDirection = "UP" | "DOWN";

interface ICounterProps {
  isActive: boolean;
  initialStartCount?: number;
  countDirection?: TCountDirection;
  intervalMs?: number;
  timeDelta?: number;
  stopValue?: number | null;
}

export const useCounter = ({
  isActive = true,
  initialStartCount = 0,
  countDirection = "UP",
  intervalMs = 1000,
  timeDelta = 1,
  stopValue = null,
}: ICounterProps) => {
  const countingUp = countDirection === "UP";

  // throw errors if impossible values provided eg counting to unachieveable number
  // if (countingUp && initialStartCount )

  const [count, setCount] = useState(initialStartCount);

  const decrementFunction = () =>
    setCount((time) =>
      stopValue && time - timeDelta < stopValue ? stopValue : time - timeDelta
    );

  const incrementFunction = () =>
    setCount((time) =>
      stopValue && time + timeDelta > stopValue ? stopValue : time + timeDelta
    );

  const functionToCall = countingUp ? incrementFunction : decrementFunction;

  let intervalId: NodeJS.Timeout;

  useEffect(() => {
    if (isActive) intervalId = setInterval(functionToCall, intervalMs);
  }, [isActive]);

  useEffect(() => {
    if (
      stopValue &&
      ((countingUp && count >= stopValue) ||
        (!countingUp && count <= stopValue))
    )
      intervalId && clearInterval(intervalId);
  }, [count]);

  return count;
};
